// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileEmailsMessageCell-moduleApplicantProfileEmailsMessageCell__xBfsh TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "ApplicantProfileEmailsMessageCell-moduleattachment__DLTnD IconNG-moduleiconContainer__SxWZ0";
export { _1 as "ApplicantProfileEmailsMessageCell", _2 as "attachment" }
